import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "page-403"
};
export function render(_ctx, _cache) {
  const _component_a_button = _resolveComponent("a-button");
  const _component_a_space = _resolveComponent("a-space");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[4] || (_cache[4] = _createElementVNode("h1", null, "403", -1)), _cache[5] || (_cache[5] = _createElementVNode("h2", null, "抱歉，您无权访问此页面！", -1)), _createVNode(_component_a_space, null, {
    default: _withCtx(() => [_createVNode(_component_a_button, {
      type: "primary",
      onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.push('/'))
    }, {
      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("首页", -1)]))]),
      _: 1
    }), _createVNode(_component_a_button, {
      type: "text",
      onClick: _cache[1] || (_cache[1] = $event => _ctx.$router.go(-1))
    }, {
      default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("返回", -1)]))]),
      _: 1
    })]),
    _: 1
  })]);
}